import angular from "angular";
import AdminStaffEditController from "./admin-edit-staff.controller";
import template from "./admin-edit-staff.html";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.staff.edit", {
    url: "/:staffId/edit",
    controller: AdminStaffEditController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.staff.edit", [])
  .config(config)
  .controller("AdminStaffEditController", AdminStaffEditController);

